import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { FaLinkedinIn, FaFacebookF, FaYoutube, FaTiktok } from 'react-icons/fa';
import Logo from '../ui/Logo';

const PublicFooter = () => {
  return (
    <footer className="bg-charcoal-50 dark:bg-charcoal-950 border-t border-charcoal-200 dark:border-charcoal-800 py-12 transition-colors">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col items-center justify-center mb-8">
          <div className="mb-4">
            <Logo />
          </div>
          <p className="text-charcoal-500 dark:text-charcoal-400 text-sm font-medium text-center max-w-md">
            The Strategic Operations Platform Powering Fractional CMO Engagements
          </p>
        </div>
      </div>
    </footer>
  );
};

export default PublicFooter;
